import { Dialog, Box, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useTheme, Chip, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const FollowUpHistory = ({ open, onClose, history, ticketId, }) => {
    const theme = useTheme();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="h5" fontWeight="bold" color='secondary'>
                        Follow-up History {ticketId ? `- #${ticketId}` : ''}
                    </Typography>
                    <IconButton onClick={onClose} sx={{ borderRadius: '50%' }}>
                        <CloseIcon color="error" />
                    </IconButton>
                </Box>

                {history.length === 0 ? (
                    <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center', fontSize: '1.1rem' }}>
                        No follow-up entries found for this ticket. Please do the follow up and check again.!
                    </Typography>
                ) : (
                    <TableContainer component={Paper} elevation={2}
                        sx={{
                            maxHeight: '40vh',
                            borderRadius: 2,
                        }}
                    >
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    {['Ticket No', 'FollowBy', 'ToDo', 'Remark', 'Date'].map((head) => (
                                        <TableCell
                                            key={head}
                                            sx={{
                                                fontWeight: 600,
                                                backgroundColor: 'grey.100',
                                                borderBottom: '2px solid',
                                                borderColor: 'divider',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {head}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {history.map((entry, idx) => (
                                    <TableRow key={idx} hover
                                        sx={{
                                            backgroundColor: idx % 2 === 0 ? 'background.paper' : 'grey.50',
                                            '& td': {
                                                verticalAlign: 'top',
                                                py: 1,
                                            },
                                        }}
                                    >
                                        <TableCell sx={{ fontWeight: 500 }}>
                                            <Chip size='small'
                                                label={entry.TicketNo || 'N/A'}
                                                sx={{
                                                    fontSize: '0.75rem',
                                                    bgcolor: '#e3f2fd',
                                                    color: '#0288d1',
                                                    border: '1px solid #81d4fa',
                                                    fontWeight: 600,
                                                    height: 20,
                                                    paddingY: '2px',
                                                    '& .MuiChip-label': {
                                                        px: 1,
                                                    },
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>{entry.FlwUser ? entry.FlwUser : entry.ResidentName || '-'}</TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                                                <Tooltip title={entry.ToDo} arrow>
                                                    {entry.ToDo && entry.ToDo.length > 20 ? `${entry.ToDo.substring(0, 20)}...` : entry.ToDo || '-'}
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    width: '100%',
                                                }}
                                            >
                                                <Tooltip title={entry.Remark} arrow>
                                                    {entry.Remark && entry.Remark.length > 20 ? `${entry.Remark.substring(0, 20)}...` : entry.Remark || '-'}
                                                </Tooltip>
                                            </Typography>
                                        </TableCell>

                                        <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                            <Typography variant="caption">
                                                {entry.FlwDt ? new Date(entry.FlwDt).toLocaleString('en-IN', {
                                                    dateStyle: 'medium',
                                                    timeStyle: 'short',
                                                })
                                                    : '-'}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Dialog>
    );
};

export default FollowUpHistory;
